// import { baseApi } from "./baseApi";

// /**
//  * Normalizes post data from different API response formats
//  * Handles both profile posts and saved posts structures
//  */

// export const postApi = baseApi.injectEndpoints({
//   endpoints: (builder) => ({

//     // ==================== QUERIES ====================

//     // GET ALL POSTS with pagination
//     getPosts: builder.query({
//       query: ({ cursor, pageSize = 20 } = {}) => {
//         const params = { pageSize };
//         if (cursor) params.cursor = cursor;

//         return {
//           url: '/Post',
//           params,
//         };
//       },

//       transformResponse: (response) => {
//         const items = response?.items?.$values ?? [];
//         return {
//           items: items,
//           nextCursor: response?.nextCursor ?? null,
//         };
//       },

//       providesTags: (result) =>
//         result?.items?.length
//           ? [
//             ...result.items.map(({ id }) => ({ type: 'Post', id })),
//             { type: 'Post', id: 'LIST' },
//           ]
//           : [{ type: 'Post', id: 'LIST' }],

//       // Merge pages for infinite scroll
//       serializeQueryArgs: ({ endpointName }) => {
//         return endpointName;
//       },

//       merge: (currentCache, newItems, { arg }) => {
//         // If no cursor (first page), replace cache
//         if (!arg?.cursor) {
//           return newItems;
//         }

//         // Otherwise, append items
//         return {
//           ...newItems,
//           items: [...(currentCache?.items || []), ...newItems.items],
//         };
//       },

//       forceRefetch({ currentArg, previousArg }) {
//         return currentArg?.cursor !== previousArg?.cursor;
//       },
//     }),

//     getPostById: builder.query({
//       query: ({ postId, type }) => ({
//         url: `/Post/${postId}`,
//         params: { type },
//       }),
//       transformResponse: (response) => response?.data ?? response,
//       providesTags: (result, error, { postId }) => [{ type: 'Post', id: postId }],
//       refetchOnMountOrArgChange: true,
//     }),

//     // GET PROFILE POSTS
//     getProfilePosts: builder.query({
//       query: ({ userId, cursor, pageSize = 10 } = {}) => {
//         const params = { pageSize };

//         if (userId) {
//           params.userId = userId;
//         }

//         if (cursor) {
//           params.cursor = cursor;
//         }

//         return {
//           url: "/Post/profile",
//           params,
//         };
//       },

//       transformResponse: (response) => {
//         const items = response?.items?.$values ?? [];

//         return {
//           items: items,
//           nextCursor: response?.nextCursor ?? null,
//         };
//       },

//       providesTags: (result, error, arg) =>
//         result?.items?.length
//           ? [
//             ...result.items.map(({ id }) => ({ type: "Post", id })),
//             { type: "Post", id: `PROFILE_${arg?.userId || 'current'}` },
//           ]
//           : [{ type: "Post", id: `PROFILE_${arg?.userId || 'current'}` }],

//       // Add pagination support similar to getPosts
//       serializeQueryArgs: ({ endpointName, queryArgs }) => {
//         return `${endpointName}_${queryArgs?.userId || 'current'}`;
//       },

//       merge: (currentCache, newItems, { arg }) => {
//         if (!arg?.cursor) {
//           return newItems;
//         }

//         return {
//           ...newItems,
//           items: [...(currentCache?.items || []), ...newItems.items],
//         };
//       },

//       forceRefetch({ currentArg, previousArg }) {
//         return currentArg?.cursor !== previousArg?.cursor || currentArg?.userId !== previousArg?.userId;
//       },
//     }),

//     // GET POST COMMENTS
//     getPostComments: builder.query({
//       query: ({ postId, type }) => `/Post/${postId}/comments?type=${type}`,

//       transformResponse: (response) => {
//         const normalize = (commentsWrapper) => {
//           const comments = commentsWrapper?.$values || [];

//           const mapComment = (comment) => ({
//             id: comment.id,
//             commentText: comment.commentText,
//             createdAt: comment.createdAt,
//             user: {
//               id: comment?.user?.id,
//               name: comment?.user?.name,
//               profilePhotoUrl: comment?.user?.profilePhotoUrl,
//             },
//             replies: comment?.replies?.$values
//               ? comment.replies.$values.map(mapComment)
//               : [],
//           });

//           return comments.map(mapComment);
//         };

//         return normalize(response);
//       },

//       providesTags: (result, error, { postId }) => [
//         { type: 'Comments', id: postId },
//       ],
//     }),

//     // GET SAVED POSTS
//     getSavedPosts: builder.query({
//       query: () => "/Post/saved",

//       transformResponse: (response) => {
//         const posts = response?.$values ?? [];
//         return posts;
//       },

//       providesTags: (result) =>
//         result?.length
//           ? [
//             ...result.map(({ id }) => ({ type: 'Post', id })),
//             { type: 'SavedPosts', id: 'LIST' },
//           ]
//           : [{ type: 'SavedPosts', id: 'LIST' }],
//     }),

//     // GET NOTIFICATIONS
//     getPostNotifications: builder.query({
//       query: () => "/Post/notifications",

//       transformResponse: (response) => {
//         const list = response?.$values ?? response ?? [];

//         return list.map(n => ({
//           id: n.id,
//           type: n.type,
//           isRead: n.isRead,
//           createdAt: n.createdAt,
//           sender: {
//             id: n.senderUser?.id,
//             name: n.senderUser?.name,
//             profilePhotoUrl: n.senderUser?.profilePhotoUrl,
//           }
//         }));
//       },

//       providesTags: ['PostNotifications'],
//     }),

//     // ==================== MUTATIONS ====================

//     // CREATE POST
//     createPost: builder.mutation({
//       query: (postData) => ({
//         url: "/Post",
//         method: "POST",
//         body: postData,
//       }),

//       invalidatesTags: [
//         { type: 'Post', id: 'LIST' },
//         { type: 'Post', id: 'PROFILE_current' }
//       ],
//     }),

//     // LIKE POST with optimistic update
//     likePost: builder.mutation({
//       query: ({postId, postType}) => ({
//         url: `/Post/${postId}/like?type=${postType}`,
//         method: "POST",
//       }),

//       // Optimistic cache update for immediate UI feedback
//       async onQueryStarted({postId, postType}, { dispatch, queryFulfilled, getState }) {
//         const patches = [];

//         // Update main feed cache
//         const feedPatch = dispatch(
//           postApi.util.updateQueryData("getPosts", undefined, (draft) => {
//             const post = draft?.items?.find(p => p.id === postId);
//             if (post) {
//               const wasLiked = post.isLikedByMe;
//               post.isLikedByMe = !wasLiked;
//               post.likesCount = Math.max(0, (post.likesCount || 0) + (wasLiked ? -1 : 1));
//             }
//           })
//         );
//         patches.push(feedPatch);

//         // Update all profile posts caches (serializeQueryArgs aware)
//         const state = getState();

//         const profileQueryKeys = Object.keys(state.api.queries).filter(
//           (key) => key.startsWith('getProfilePosts_')
//         );

//         profileQueryKeys.forEach((cacheKey) => {
//           const userId = cacheKey.replace('getProfilePosts_', '');

//           const args =
//             userId === 'current'
//               ? { userId: undefined }
//               : { userId };

//           const patch = dispatch(
//             postApi.util.updateQueryData('getProfilePosts', args, (draft) => {
//               const post = draft?.items?.find((p) => p.id === postId);
//               if (!post) return;

//               const wasLiked = post.isLikedByMe;
//               post.isLikedByMe = !wasLiked;
//               post.likesCount = Math.max(
//                 0,
//                 (post.likesCount || 0) + (wasLiked ? -1 : 1)
//               );
//             })
//           );

//           patches.push(patch);
//         });

//         // Update saved posts cache
//         const savedPatch = dispatch(
//           postApi.util.updateQueryData("getSavedPosts", undefined, (draft) => {
//             const post = draft?.find(p => p.id === postId);
//             if (post) {
//               const wasLiked = post.isLikedByMe;
//               post.isLikedByMe = !wasLiked;
//               post.likesCount = Math.max(0, (post.likesCount || 0) + (wasLiked ? -1 : 1));
//             }
//           })
//         );
//         patches.push(savedPatch);

//         // ✅ ADD THIS — finds the cache entry by matching response data, uses originalArgs
//         Object.keys(state.api.queries)
//           .filter(key => key.startsWith('getPostById('))
//           .forEach(key => {
//             const queryState = state.api.queries[key];
//             // Match by the actual id stored in the response (handles string/number mismatch)
//             const cachedId = queryState?.data?.id;
//             if (cachedId == null || String(cachedId) !== String(postId)) return;

//             const originalArgs = queryState.originalArgs;
//             if (!originalArgs) return;

//             const patch = dispatch(
//               postApi.util.updateQueryData('getPostById', originalArgs, (draft) => {
//                 if (draft) {
//                   const wasLiked = draft.isLikedByMe;
//                   draft.isLikedByMe = !wasLiked;
//                   draft.likesCount = Math.max(0, (draft.likesCount || 0) + (wasLiked ? -1 : 1));
//                 }
//               })
//             );
//             patches.push(patch);
//           });

//         try {
//           await queryFulfilled;
//         } catch {
//           // Rollback all patches on failure
//           patches.forEach(patch => patch.undo());
//         }
//       },
//     }),

//     // UNLIKE POST with optimistic update
//     unlikePost: builder.mutation({
//       query: ({postId, postType}) => ({
//         url: `/Post/${postId}/unlike?type=${postType}`,
//         method: "DELETE",
//       }),

//       async onQueryStarted({postId, postType}, { dispatch, queryFulfilled, getState }) {
//         const patches = [];

//         // Update main feed cache
//         const feedPatch = dispatch(
//           postApi.util.updateQueryData("getPosts", undefined, (draft) => {
//             const post = draft?.items?.find(p => p.id === postId);
//             if (post && post.isLikedByMe) {
//               post.isLikedByMe = false;
//               post.likesCount = Math.max(0, (post.likesCount || 0) - 1);
//             }
//           })
//         );
//         patches.push(feedPatch);

//         // Update all profile posts caches
//         const state = getState();
//         const profileQueryKeys = Object.keys(state.api.queries).filter(
//           (key) => key.startsWith("getProfilePosts_")
//         );

//         profileQueryKeys.forEach((cacheKey) => {
//           const userId = cacheKey.replace("getProfilePosts_", "");

//           const args =
//             userId === "current"
//               ? { userId: undefined }
//               : { userId };

//           const patch = dispatch(
//             postApi.util.updateQueryData("getProfilePosts", args, (draft) => {
//               const post = draft?.items?.find(p => p.id === postId);
//               if (post && post.isLikedByMe) {
//                 post.isLikedByMe = false;
//                 post.likesCount = Math.max(
//                   0,
//                   (post.likesCount || 0) - 1
//                 );
//               }
//             })
//           );

//           patches.push(patch);
//         });

//         // Update saved posts cache
//         const savedPatch = dispatch(
//           postApi.util.updateQueryData("getSavedPosts", undefined, (draft) => {
//             const post = draft?.find(p => p.id === postId);
//             if (post && post.isLikedByMe) {
//               post.isLikedByMe = false;
//               post.likesCount = Math.max(0, (post.likesCount || 0) - 1);
//             }
//           })
//         );
//         patches.push(savedPatch);

//         // ✅ ADD THIS:
//         Object.keys(state.api.queries)
//           .filter(key => key.startsWith('getPostById('))
//           .forEach(key => {
//             const queryState = state.api.queries[key];
//             const cachedId = queryState?.data?.id;
//             if (cachedId == null || String(cachedId) !== String(postId)) return;

//             const originalArgs = queryState.originalArgs;
//             if (!originalArgs) return;

//             const patch = dispatch(
//               postApi.util.updateQueryData('getPostById', originalArgs, (draft) => {
//                 if (draft && draft.isLikedByMe) {
//                   draft.isLikedByMe = false;
//                   draft.likesCount = Math.max(0, (draft.likesCount || 0) - 1);
//                 }
//               })
//             );
//             patches.push(patch);
//           });

//         try {
//           await queryFulfilled;
//         } catch {
//           // rollback on failure
//           patches.forEach(patch => patch.undo());
//         }
//       },
//     }),

//     // SAVE POST with optimistic update
//     savePost: builder.mutation({
//       query: ({ postId, type }) => ({
//         url: `/Post/${postId}/save?type=${type}`,
//         method: "POST",
//       }),

//       async onQueryStarted({ postId }, { dispatch, queryFulfilled, getState }) {
//         const patches = [];

//         // Update feed cache
//         const feedPatch = dispatch(
//           postApi.util.updateQueryData("getPosts", undefined, (draft) => {
//             const post = draft?.items?.find(p => p.id === postId);
//             if (post) {
//               post.isSaved = true;
//             }
//           })
//         );
//         patches.push(feedPatch);

//         // Update all profile caches
//         const state = getState();
//         const profileQueries = Object.keys(state.api.queries).filter(key =>
//           key.startsWith('getProfilePosts')
//         );

//         profileQueries.forEach(queryKey => {
//           const match = queryKey.match(/getProfilePosts\((.*)\)/);
//           if (match) {
//             try {
//               const args = JSON.parse(match[1] || '{}');
//               const patch = dispatch(
//                 postApi.util.updateQueryData("getProfilePosts", args, (draft) => {
//                   const post = draft?.items?.find(p => p.id === postId);
//                   if (post) {
//                     post.isSaved = true;
//                   }
//                 })
//               );
//               patches.push(patch);
//             } catch (e) {
//               console.error('Error updating profile cache:', e);
//             }
//           }
//         });

//         try {
//           await queryFulfilled;
//         } catch {
//           patches.forEach(patch => patch.undo());
//         }
//       },

//       invalidatesTags: [{ type: 'SavedPosts', id: 'LIST' }],
//     }),

//     // UNSAVE POST with optimistic update
//     unsavePost: builder.mutation({
//       query: ({ postId, type }) => ({
//         url: `/Post/${postId}/unsave?type=${type}`,
//         method: "DELETE",
//       }),

//       async onQueryStarted({ postId }, { dispatch, queryFulfilled, getState }) {
//         const patches = [];

//         // Update feed cache
//         const feedPatch = dispatch(
//           postApi.util.updateQueryData("getPosts", undefined, (draft) => {
//             const post = draft?.items?.find(p => p.id === postId);
//             if (post) {
//               post.isSaved = false;
//             }
//           })
//         );
//         patches.push(feedPatch);

//         // Update all profile caches
//         const state = getState();
//         const profileQueries = Object.keys(state.api.queries).filter(key =>
//           key.startsWith('getProfilePosts')
//         );

//         profileQueries.forEach(queryKey => {
//           const match = queryKey.match(/getProfilePosts\((.*)\)/);
//           if (match) {
//             try {
//               const args = JSON.parse(match[1] || '{}');
//               const patch = dispatch(
//                 postApi.util.updateQueryData("getProfilePosts", args, (draft) => {
//                   const post = draft?.items?.find(p => p.id === postId);
//                   if (post) {
//                     post.isSaved = false;
//                   }
//                 })
//               );
//               patches.push(patch);
//             } catch (e) {
//               console.error('Error updating profile cache:', e);
//             }
//           }
//         });

//         // Remove from saved posts cache
//         const savedPatch = dispatch(
//           postApi.util.updateQueryData("getSavedPosts", undefined, (draft) => {
//             return draft.filter(p => p.id !== postId);
//           })
//         );
//         patches.push(savedPatch);

//         try {
//           await queryFulfilled;
//         } catch {
//           patches.forEach(patch => patch.undo());
//         }
//       },

//       invalidatesTags: [{ type: 'SavedPosts', id: 'LIST' }],
//     }),

//     // COMMENT ON POST
//     commentOnPost: builder.mutation({
//       query: ({ postId, commentText, parentCommentId, type }) => ({
//         url: `/Post/${postId}/comment?type=${type}`,
//         method: 'POST',
//         body: {
//           postId,
//           commentText,
//           parentCommentId: parentCommentId ?? null,
//         },
//         headers: {
//           'Content-Type': 'application/json',
//         },
//       }),

//       // ✅ MUST BE OUTSIDE query
//       invalidatesTags: (result, error, { postId }) => [
//         { type: 'Comments', id: postId },
//       ],

//       async onQueryStarted(
//         { postId },
//         { dispatch, queryFulfilled, getState }
//       ) {
//         const patches = [];

//         // Update feed cache
//         const feedPatch = dispatch(
//           postApi.util.updateQueryData("getPosts", undefined, (draft) => {
//             const post = draft?.items?.find(p => p.id === postId);
//             if (post) {
//               post.commentsCount = (post.commentsCount || 0) + 1;
//             }
//           })
//         );
//         patches.push(feedPatch);

//         // Update profile caches
//         const state = getState();
//         const profileQueries = Object.keys(state.api.queries).filter(key =>
//           key.startsWith('getProfilePosts')
//         );

//         profileQueries.forEach(queryKey => {
//           const match = queryKey.match(/getProfilePosts\((.*)\)/);
//           if (match) {
//             try {
//               const args = JSON.parse(match[1] || '{}');
//               const patch = dispatch(
//                 postApi.util.updateQueryData("getProfilePosts", args, (draft) => {
//                   const post = draft?.items?.find(p => p.id === postId);
//                   if (post) {
//                     post.commentsCount = (post.commentsCount || 0) + 1;
//                   }
//                 })
//               );
//               patches.push(patch);
//             } catch (e) {
//               console.error('Error updating profile cache:', e);
//             }
//           }
//         });

//         // Update saved posts
//         const savedPatch = dispatch(
//           postApi.util.updateQueryData("getSavedPosts", undefined, (draft) => {
//             const post = draft?.find(p => p.id === postId);
//             if (post) {
//               post.commentsCount = (post.commentsCount || 0) + 1;
//             }
//           })
//         );
//         patches.push(savedPatch);

//         try {
//           await queryFulfilled;
//         } catch {
//           patches.forEach(patch => patch.undo());
//         }
//       },
//     }),
//     // DELETE COMMENT
//     deleteComment: builder.mutation({
//       query: ({ commentId }) => ({
//         url: `/Post/comment/${commentId}`,
//         method: "DELETE",
//       }),

//       invalidatesTags: (result, error, { postId }) => [
//         { type: 'Comments', id: postId },
//       ],

//       async onQueryStarted(
//         { postId },
//         { dispatch, queryFulfilled, getState }
//       ) {
//         const patches = [];

//         // Feed update
//         const feedPatch = dispatch(
//           postApi.util.updateQueryData("getPosts", undefined, (draft) => {
//             const post = draft?.items?.find(p => p.id === postId);
//             if (post) {
//               post.commentsCount = Math.max(
//                 0,
//                 (post.commentsCount || 0) - 1
//               );
//             }
//           })
//         );
//         patches.push(feedPatch);

//         // Profile posts update
//         const state = getState();

//         const profileQueryKeys = Object.keys(state.api.queries).filter(
//           (key) => key.startsWith("getProfilePosts_")
//         );

//         profileQueryKeys.forEach((cacheKey) => {
//           const userId = cacheKey.replace("getProfilePosts_", "");

//           const args =
//             userId === "current"
//               ? { userId: undefined }
//               : { userId };

//           const patch = dispatch(
//             postApi.util.updateQueryData(
//               "getProfilePosts",
//               args,
//               (draft) => {
//                 const post = draft?.items?.find(
//                   (p) => p.id === postId
//                 );
//                 if (post) {
//                   post.commentsCount = Math.max(
//                     0,
//                     (post.commentsCount || 0) - 1
//                   );
//                 }
//               }
//             )
//           );

//           patches.push(patch);
//         });

//         // Saved posts update
//         const savedPatch = dispatch(
//           postApi.util.updateQueryData(
//             "getSavedPosts",
//             undefined,
//             (draft) => {
//               const post = draft?.find(p => p.id === postId);
//               if (post) {
//                 post.commentsCount = Math.max(
//                   0,
//                   (post.commentsCount || 0) - 1
//                 );
//               }
//             }
//           )
//         );
//         patches.push(savedPatch);

//         try {
//           await queryFulfilled;
//         } catch {
//           patches.forEach(p => p.undo());
//         }
//       },
//     }),
//     // UPDATE POST
//     updatePost: builder.mutation({
//       query: ({ postId, postType, caption, visibility }) => ({
//         url: `/Post/${postId}?type=${postType}`,
//         method: "PUT",
//         body: {
//           caption,
//           visibility,
//         },
//         headers: {
//           "Content-Type": "application/json",
//         },
//       }),

//       invalidatesTags: (result, error, { postId }) => [
//         { type: "Post", id: postId },
//         { type: "Post", id: "LIST" },
//         { type: "Post", id: "PROFILE_current" }
//       ],
//     }),

//     // DELETE POST
//     deletePost: builder.mutation({
//       query: ({ postId, postType }) => ({
//         url: `/Post/delete/${postId}?type=${postType}`,
//         method: "DELETE",
//       }),

//       invalidatesTags: (result, error, { postId }) => [
//         { type: 'Post', id: postId },
//       ],
//     }),

//     // SHARE POST (Feed Share with caption)
//     sharePost: builder.mutation({
//       query: ({ originalPostId, caption }) => ({
//         url: `/Post/share`,
//         method: "POST",
//         body: {
//           originalPostId,
//           caption,
//         },
//         headers: {
//           "Content-Type": "application/json",
//         },
//       }),

//       invalidatesTags: [
//         { type: "Post", id: "LIST" },
//         { type: "Post", id: "PROFILE_current" },
//       ],
//     }),

//     // REPORT POST
//     reportPost: builder.mutation({
//       query: ({ postId, reason, description }) => ({
//         url: `/Post/${postId}/report`,
//         method: "POST",
//         body: { reason, description },
//         headers: {
//           'Content-Type': 'application/json',
//         }
//       }),
//     }),
//     // GET USERS WHO LIKED A POST
//     getPostLikes: builder.query({
//       query: ({ postId, type, page = 1, pageSize = 20 }) => ({
//         url: `/Post/${postId}/likes?type=${type}`,
//         params: { page, pageSize }
//       }),
//       transformResponse: (response) => response?.$values ?? []
//     }),

//   }),
// });

// // Export all hooks
// export const {
//   // Queries
//   useGetPostsQuery,
//   useLazyGetPostsQuery,
//   useGetPostByIdQuery,
//   useGetProfilePostsQuery,
//   useLazyGetProfilePostsQuery,
//   useGetSavedPostsQuery,
//   useGetPostNotificationsQuery,
//   useGetPostLikesQuery,
//   // Mutations
//   useCreatePostMutation,
//   useLikePostMutation,
//   useUnlikePostMutation,
//   useSavePostMutation,
//   useUnsavePostMutation,
//   useCommentOnPostMutation,
//   useDeleteCommentMutation,
//   useUpdatePostMutation,
//   useDeletePostMutation,
//   useSharePostMutation,
//   useReportPostMutation,
//   useGetPostCommentsQuery,
// } = postApi;

import { baseApi } from "./baseApi";

/**
 * Normalizes post data from different API response formats
 * Handles both profile posts and saved posts structures
 */

export const postApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // ==================== QUERIES ====================

    // GET ALL POSTS with pagination
    getPosts: builder.query({
      query: ({ cursor, pageSize = 20 } = {}) => {
        const params = { pageSize };
        if (cursor) params.cursor = cursor;

        return {
          url: "/Post",
          params,
        };
      },

      transformResponse: (response) => {
        const items = response?.items?.$values ?? [];
        return {
          items: items,
          nextCursor: response?.nextCursor ?? null,
        };
      },

      providesTags: (result) =>
        result?.items?.length
          ? [
              ...result.items.map(({ id }) => ({ type: "Post", id })),
              { type: "Post", id: "LIST" },
            ]
          : [{ type: "Post", id: "LIST" }],

      // Merge pages for infinite scroll
      serializeQueryArgs: ({ endpointName }) => {
        return endpointName;
      },

      merge: (currentCache, newItems, { arg }) => {
        // If no cursor (first page), replace cache
        if (!arg?.cursor) {
          return newItems;
        }

        // Otherwise, append items
        return {
          ...newItems,
          items: [...(currentCache?.items || []), ...newItems.items],
        };
      },

      forceRefetch({ currentArg, previousArg }) {
        return currentArg?.cursor !== previousArg?.cursor;
      },
    }),

    getPostById: builder.query({
      query: ({ postId, type }) => ({
        url: `/Post/${postId}`,
        params: { type },
      }),
      transformResponse: (response) => response?.data ?? response,
      providesTags: (result, error, { postId }) => [
        { type: "Post", id: postId },
      ],
      refetchOnMountOrArgChange: true,
    }),

    // GET PROFILE POSTS
    getProfilePosts: builder.query({
      query: ({ userId, cursor, pageSize = 10 } = {}) => {
        const params = { pageSize };

        if (userId) {
          params.userId = userId;
        }

        if (cursor) {
          params.cursor = cursor;
        }

        return {
          url: "/Post/profile",
          params,
        };
      },

      transformResponse: (response) => {
        const items = response?.items?.$values ?? [];

        return {
          items: items,
          nextCursor: response?.nextCursor ?? null,
        };
      },

      providesTags: (result, error, arg) =>
        result?.items?.length
          ? [
              ...result.items.map(({ id }) => ({ type: "Post", id })),
              { type: "Post", id: `PROFILE_${arg?.userId || "current"}` },
            ]
          : [{ type: "Post", id: `PROFILE_${arg?.userId || "current"}` }],

      // Add pagination support similar to getPosts
      serializeQueryArgs: ({ endpointName, queryArgs }) => {
        return `${endpointName}_${queryArgs?.userId || "current"}`;
      },

      merge: (currentCache, newItems, { arg }) => {
        if (!arg?.cursor) {
          return newItems;
        }

        return {
          ...newItems,
          items: [...(currentCache?.items || []), ...newItems.items],
        };
      },

      forceRefetch({ currentArg, previousArg }) {
        return (
          currentArg?.cursor !== previousArg?.cursor ||
          currentArg?.userId !== previousArg?.userId
        );
      },
    }),

    // GET POST COMMENTS
    getPostComments: builder.query({
      query: ({ postId, type }) => `/Post/${postId}/comments?type=${type}`,

      transformResponse: (response) => {
        const normalize = (commentsWrapper) => {
          const comments = commentsWrapper?.$values || [];

          const mapComment = (comment) => ({
            id: comment.id,
            commentText: comment.commentText,
            createdAt: comment.createdAt,
            user: {
              id: comment?.user?.id,
              name: comment?.user?.name,
              profilePhotoUrl: comment?.user?.profilePhotoUrl,
            },
            replies: comment?.replies?.$values
              ? comment.replies.$values.map(mapComment)
              : [],
          });

          return comments.map(mapComment);
        };

        return normalize(response);
      },

      providesTags: (result, error, { postId }) => [
        { type: "Comments", id: postId },
      ],
    }),

    // GET SAVED POSTS
    getSavedPosts: builder.query({
      query: () => "/Post/saved",

      transformResponse: (response) => {
        const posts = response?.$values ?? [];
        return posts;
      },

      providesTags: (result) =>
        result?.length
          ? [
              ...result.map(({ id }) => ({ type: "Post", id })),
              { type: "SavedPosts", id: "LIST" },
            ]
          : [{ type: "SavedPosts", id: "LIST" }],
    }),

    // GET NOTIFICATIONS
    getPostNotifications: builder.query({
      query: () => "/Post/notifications",

      transformResponse: (response) => {
        const list = response?.$values ?? response ?? [];

        return list.map((n) => ({
          id: n.id,
          type: n.type,
          isRead: n.isRead,
          createdAt: n.createdAt,
          sender: {
            id: n.senderUser?.id,
            name: n.senderUser?.name,
            profilePhotoUrl: n.senderUser?.profilePhotoUrl,
          },
        }));
      },

      providesTags: ["PostNotifications"],
    }),

    // ==================== MUTATIONS ====================

    // CREATE POST
    createPost: builder.mutation({
      query: (postData) => ({
        url: "/Post",
        method: "POST",
        body: postData,
      }),

      invalidatesTags: [
        { type: "Post", id: "LIST" },
        { type: "Post", id: "PROFILE_current" },
      ],
    }),

    // LIKE POST with optimistic update
    likePost: builder.mutation({
      query: ({ postId, postType }) => ({
        url: `/Post/${postId}/like?type=${postType}`,
        method: "POST",
      }),

      // Optimistic cache update for immediate UI feedback
      async onQueryStarted(
        { postId, postType },
        { dispatch, queryFulfilled, getState },
      ) {
        const patches = [];

        // Update main feed cache
        const feedPatch = dispatch(
          postApi.util.updateQueryData("getPosts", undefined, (draft) => {
            const post = draft?.items?.find((p) => p.id === postId);
            if (post) {
              const wasLiked = post.isLikedByMe;
              post.isLikedByMe = !wasLiked;
              post.likesCount = Math.max(
                0,
                (post.likesCount || 0) + (wasLiked ? -1 : 1),
              );
            }
          }),
        );
        patches.push(feedPatch);

        // Update all profile posts caches (serializeQueryArgs aware)
        const state = getState();

        const profileQueryKeys = Object.keys(state.api.queries).filter((key) =>
          key.startsWith("getProfilePosts_"),
        );

        profileQueryKeys.forEach((cacheKey) => {
          const userId = cacheKey.replace("getProfilePosts_", "");

          const args =
            userId === "current" ? { userId: undefined } : { userId };

          const patch = dispatch(
            postApi.util.updateQueryData("getProfilePosts", args, (draft) => {
              const post = draft?.items?.find((p) => p.id === postId);
              if (!post) return;

              const wasLiked = post.isLikedByMe;
              post.isLikedByMe = !wasLiked;
              post.likesCount = Math.max(
                0,
                (post.likesCount || 0) + (wasLiked ? -1 : 1),
              );
            }),
          );

          patches.push(patch);
        });

        // Update saved posts cache
        const savedPatch = dispatch(
          postApi.util.updateQueryData("getSavedPosts", undefined, (draft) => {
            const post = draft?.find((p) => p.id === postId);
            if (post) {
              const wasLiked = post.isLikedByMe;
              post.isLikedByMe = !wasLiked;
              post.likesCount = Math.max(
                0,
                (post.likesCount || 0) + (wasLiked ? -1 : 1),
              );
            }
          }),
        );
        patches.push(savedPatch);

        // ✅ ADD THIS — finds the cache entry by matching response data, uses originalArgs
        Object.keys(state.api.queries)
          .filter((key) => key.startsWith("getPostById("))
          .forEach((key) => {
            const queryState = state.api.queries[key];
            // Match by the actual id stored in the response (handles string/number mismatch)
            const cachedId = queryState?.data?.id;
            if (cachedId == null || String(cachedId) !== String(postId)) return;

            const originalArgs = queryState.originalArgs;
            if (!originalArgs) return;

            const patch = dispatch(
              postApi.util.updateQueryData(
                "getPostById",
                originalArgs,
                (draft) => {
                  if (draft) {
                    const wasLiked = draft.isLikedByMe;
                    draft.isLikedByMe = !wasLiked;
                    draft.likesCount = Math.max(
                      0,
                      (draft.likesCount || 0) + (wasLiked ? -1 : 1),
                    );
                  }
                },
              ),
            );
            patches.push(patch);
          });

        try {
          await queryFulfilled;
        } catch {
          // Rollback all patches on failure
          patches.forEach((patch) => patch.undo());
        }
      },
    }),

    // UNLIKE POST with optimistic update
    unlikePost: builder.mutation({
      query: ({ postId, postType }) => ({
        url: `/Post/${postId}/unlike?type=${postType}`,
        method: "DELETE",
      }),

      async onQueryStarted(
        { postId, postType },
        { dispatch, queryFulfilled, getState },
      ) {
        const patches = [];

        // Update main feed cache
        const feedPatch = dispatch(
          postApi.util.updateQueryData("getPosts", undefined, (draft) => {
            const post = draft?.items?.find((p) => p.id === postId);
            if (post && post.isLikedByMe) {
              post.isLikedByMe = false;
              post.likesCount = Math.max(0, (post.likesCount || 0) - 1);
            }
          }),
        );
        patches.push(feedPatch);

        // Update all profile posts caches
        const state = getState();
        const profileQueryKeys = Object.keys(state.api.queries).filter((key) =>
          key.startsWith("getProfilePosts_"),
        );

        profileQueryKeys.forEach((cacheKey) => {
          const userId = cacheKey.replace("getProfilePosts_", "");

          const args =
            userId === "current" ? { userId: undefined } : { userId };

          const patch = dispatch(
            postApi.util.updateQueryData("getProfilePosts", args, (draft) => {
              const post = draft?.items?.find((p) => p.id === postId);
              if (post && post.isLikedByMe) {
                post.isLikedByMe = false;
                post.likesCount = Math.max(0, (post.likesCount || 0) - 1);
              }
            }),
          );

          patches.push(patch);
        });

        // Update saved posts cache
        const savedPatch = dispatch(
          postApi.util.updateQueryData("getSavedPosts", undefined, (draft) => {
            const post = draft?.find((p) => p.id === postId);
            if (post && post.isLikedByMe) {
              post.isLikedByMe = false;
              post.likesCount = Math.max(0, (post.likesCount || 0) - 1);
            }
          }),
        );
        patches.push(savedPatch);

        // ✅ ADD THIS:
        Object.keys(state.api.queries)
          .filter((key) => key.startsWith("getPostById("))
          .forEach((key) => {
            const queryState = state.api.queries[key];
            const cachedId = queryState?.data?.id;
            if (cachedId == null || String(cachedId) !== String(postId)) return;

            const originalArgs = queryState.originalArgs;
            if (!originalArgs) return;

            const patch = dispatch(
              postApi.util.updateQueryData(
                "getPostById",
                originalArgs,
                (draft) => {
                  if (draft && draft.isLikedByMe) {
                    draft.isLikedByMe = false;
                    draft.likesCount = Math.max(0, (draft.likesCount || 0) - 1);
                  }
                },
              ),
            );
            patches.push(patch);
          });

        try {
          await queryFulfilled;
        } catch {
          // rollback on failure
          patches.forEach((patch) => patch.undo());
        }
      },
    }),

    // SAVE POST with optimistic update
    savePost: builder.mutation({
      query: ({ postId, type }) => ({
        url: `/Post/${postId}/save?type=${type}`,
        method: "POST",
      }),

      async onQueryStarted({ postId }, { dispatch, queryFulfilled, getState }) {
        const patches = [];

        // Update feed cache
        const feedPatch = dispatch(
          postApi.util.updateQueryData("getPosts", undefined, (draft) => {
            const post = draft?.items?.find((p) => p.id === postId);
            if (post) {
              post.isSaved = true;
            }
          }),
        );
        patches.push(feedPatch);

        // Update all profile caches
        const state = getState();

        const profileQueryKeys = Object.keys(state.api.queries).filter((key) =>
          key.startsWith("getProfilePosts_"),
        );

        profileQueryKeys.forEach((cacheKey) => {
          const userId = cacheKey.replace("getProfilePosts_", "");

          const args =
            userId === "current" ? { userId: undefined } : { userId };

          const patch = dispatch(
            postApi.util.updateQueryData("getProfilePosts", args, (draft) => {
              const post = draft?.items?.find(
                (p) => String(p.id) === String(postId),
              );

              if (post) {
                post.isSaved = true;
              }
            }),
          );

          patches.push(patch);
        });

        try {
          await queryFulfilled;
        } catch {
          patches.forEach((patch) => patch.undo());
        }
      },

      invalidatesTags: (result, error, { postId }) => [
        { type: "SavedPosts", id: "LIST" },
        { type: "Post", id: postId },
      ],
    }),

    // UNSAVE POST with optimistic update
    unsavePost: builder.mutation({
      query: ({ postId, type }) => ({
        url: `/Post/${postId}/unsave?type=${type}`,
        method: "DELETE",
      }),

      async onQueryStarted({ postId }, { dispatch, queryFulfilled, getState }) {
        const patches = [];

        // Update feed cache
        const feedPatch = dispatch(
          postApi.util.updateQueryData("getPosts", undefined, (draft) => {
            const post = draft?.items?.find((p) => p.id === postId);
            if (post) {
              post.isSaved = false;
            }
          }),
        );
        patches.push(feedPatch);

        // Update all profile caches
        const state = getState();

        const profileQueryKeys = Object.keys(state.api.queries).filter((key) =>
          key.startsWith("getProfilePosts_"),
        );

        profileQueryKeys.forEach((cacheKey) => {
          const userId = cacheKey.replace("getProfilePosts_", "");

          const args =
            userId === "current" ? { userId: undefined } : { userId };

          const patch = dispatch(
            postApi.util.updateQueryData("getProfilePosts", args, (draft) => {
              const post = draft?.items?.find(
                (p) => String(p.id) === String(postId),
              );

              if (post) {
                post.isSaved = false;
              }
            }),
          );

          patches.push(patch);
        });

        // Remove from saved posts cache
        const savedPatch = dispatch(
          postApi.util.updateQueryData("getSavedPosts", undefined, (draft) => {
            return draft.filter((p) => p.id !== postId);
          }),
        );
        patches.push(savedPatch);

        try {
          await queryFulfilled;
        } catch {
          patches.forEach((patch) => patch.undo());
        }
      },

      invalidatesTags: (result, error, { postId }) => [
        { type: "SavedPosts", id: "LIST" },
        { type: "Post", id: postId },
      ],
    }),

    // COMMENT ON POST
    commentOnPost: builder.mutation({
      query: ({ postId, commentText, parentCommentId, type }) => ({
        url: `/Post/${postId}/comment?type=${type}`,
        method: "POST",
        body: {
          postId,
          commentText,
          parentCommentId: parentCommentId ?? null,
        },
        headers: {
          "Content-Type": "application/json",
        },
      }),

      // ✅ MUST BE OUTSIDE query
      invalidatesTags: (result, error, { postId }) => [
        { type: "Comments", id: postId },
      ],

      async onQueryStarted({ postId }, { dispatch, queryFulfilled, getState }) {
        const patches = [];

        // Update feed cache
        const feedPatch = dispatch(
          postApi.util.updateQueryData("getPosts", undefined, (draft) => {
            const post = draft?.items?.find((p) => p.id === postId);
            if (post) {
              post.commentsCount = (post.commentsCount || 0) + 1;
            }
          }),
        );
        patches.push(feedPatch);

        // Update profile caches
        const state = getState();
        const profileQueries = Object.keys(state.api.queries).filter((key) =>
          key.startsWith("getProfilePosts"),
        );

        profileQueries.forEach((queryKey) => {
          const match = queryKey.match(/getProfilePosts\((.*)\)/);
          if (match) {
            try {
              const args = JSON.parse(match[1] || "{}");
              const patch = dispatch(
                postApi.util.updateQueryData(
                  "getProfilePosts",
                  args,
                  (draft) => {
                    const post = draft?.items?.find((p) => p.id === postId);
                    if (post) {
                      post.commentsCount = (post.commentsCount || 0) + 1;
                    }
                  },
                ),
              );
              patches.push(patch);
            } catch (e) {
              console.error("Error updating profile cache:", e);
            }
          }
        });

        // Update saved posts
        const savedPatch = dispatch(
          postApi.util.updateQueryData("getSavedPosts", undefined, (draft) => {
            const post = draft?.find((p) => p.id === postId);
            if (post) {
              post.commentsCount = (post.commentsCount || 0) + 1;
            }
          }),
        );
        patches.push(savedPatch);

        try {
          await queryFulfilled;
        } catch {
          patches.forEach((patch) => patch.undo());
        }
      },
    }),
    // DELETE COMMENT
    deleteComment: builder.mutation({
      query: ({ commentId }) => ({
        url: `/Post/comment/${commentId}`,
        method: "DELETE",
      }),

      invalidatesTags: (result, error, { postId }) => [
        { type: "Comments", id: postId },
      ],

      async onQueryStarted({ postId }, { dispatch, queryFulfilled, getState }) {
        const patches = [];

        // Feed update
        const feedPatch = dispatch(
          postApi.util.updateQueryData("getPosts", undefined, (draft) => {
            const post = draft?.items?.find((p) => p.id === postId);
            if (post) {
              post.commentsCount = Math.max(0, (post.commentsCount || 0) - 1);
            }
          }),
        );
        patches.push(feedPatch);

        // Profile posts update
        const state = getState();

        const profileQueryKeys = Object.keys(state.api.queries).filter((key) =>
          key.startsWith("getProfilePosts_"),
        );

        profileQueryKeys.forEach((cacheKey) => {
          const userId = cacheKey.replace("getProfilePosts_", "");

          const args =
            userId === "current" ? { userId: undefined } : { userId };

          const patch = dispatch(
            postApi.util.updateQueryData("getProfilePosts", args, (draft) => {
              const post = draft?.items?.find((p) => p.id === postId);
              if (post) {
                post.commentsCount = Math.max(0, (post.commentsCount || 0) - 1);
              }
            }),
          );

          patches.push(patch);
        });

        // Saved posts update
        const savedPatch = dispatch(
          postApi.util.updateQueryData("getSavedPosts", undefined, (draft) => {
            const post = draft?.find((p) => p.id === postId);
            if (post) {
              post.commentsCount = Math.max(0, (post.commentsCount || 0) - 1);
            }
          }),
        );
        patches.push(savedPatch);

        try {
          await queryFulfilled;
        } catch {
          patches.forEach((p) => p.undo());
        }
      },
    }),
    // UPDATE POST
    updatePost: builder.mutation({
      query: ({ postId, postType, caption, visibility }) => ({
        url: `/Post/${postId}?type=${postType}`,
        method: "PUT",
        body: {
          caption,
          visibility,
        },
        headers: {
          "Content-Type": "application/json",
        },
      }),

      invalidatesTags: (result, error, { postId }) => [
        { type: "Post", id: postId },
        { type: "Post", id: "LIST" },
        { type: "Post", id: "PROFILE_current" },
      ],
    }),

    // DELETE POST
    deletePost: builder.mutation({
      query: ({ postId, postType }) => ({
        url: `/Post/delete/${postId}?type=${postType}`,
        method: "DELETE",
      }),

      invalidatesTags: (result, error, { postId }) => [
        { type: "Post", id: postId },
      ],
    }),

    // SHARE POST (Feed Share with caption)
    sharePost: builder.mutation({
      query: ({ originalPostId, caption }) => ({
        url: `/Post/share`,
        method: "POST",
        body: {
          originalPostId,
          caption,
        },
        headers: {
          "Content-Type": "application/json",
        },
      }),

      invalidatesTags: [
        { type: "Post", id: "LIST" },
        { type: "Post", id: "PROFILE_current" },
      ],
    }),

    // REPORT POST
    reportPost: builder.mutation({
      // FIX: send postType as query param so backend knows Post vs SharedPost
      // postType: "Post" | "SharedPost"
      query: ({ postId, postType = "Post", reason, description }) => ({
        url: `/Post/${postId}/report?type=${postType}`,
        method: "POST",
        body: { reason, description },
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
    // GET USERS WHO LIKED A POST
    getPostLikes: builder.query({
      query: ({ postId, type, page = 1, pageSize = 20 }) => ({
        url: `/Post/${postId}/likes?type=${type}`,
        params: { page, pageSize },
      }),
      transformResponse: (response) => response?.$values ?? [],
    }),
  }),
});

// Export all hooks
export const {
  // Queries
  useGetPostsQuery,
  useLazyGetPostsQuery,
  useGetPostByIdQuery,
  useGetProfilePostsQuery,
  useLazyGetProfilePostsQuery,
  useGetSavedPostsQuery,
  useGetPostNotificationsQuery,
  useGetPostLikesQuery,
  // Mutations
  useCreatePostMutation,
  useLikePostMutation,
  useUnlikePostMutation,
  useSavePostMutation,
  useUnsavePostMutation,
  useCommentOnPostMutation,
  useDeleteCommentMutation,
  useUpdatePostMutation,
  useDeletePostMutation,
  useSharePostMutation,
  useReportPostMutation,
  useGetPostCommentsQuery,
} = postApi;
